<template>
    <b-card class="px-1">
        <!-- Card Header -->
        <b-row class="text-center">
            <b-col>
                <b-alert
                    variant="warning"
                    show
                    class="font-weight-bold py-1"
                    style="font-size: 0.7em; width: 45%"
                >
                    {{ order.type.name.toUpperCase() }}
                </b-alert>
            </b-col>
            <b-col cols="4" class="text-right">
                <b-dropdown
                    id="issue-dropdown"
                    offset="-50"
                    variant="light"
                    no-caret
                >
                    <template #button-content>
                        <b-icon-three-dots-vertical>
                        </b-icon-three-dots-vertical>
                    </template>
                    <b-dropdown-item
                        :to="`/customer-portal/view-service/${order.id}`"
                    >
                        View Order Request
                    </b-dropdown-item>
                    <b-dropdown-item> Mark As Completed </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>
        <b-row>
            <h3 class="font-weight-bold ml-3">
                {{ (order.description || '').slice(0, 25) }}
            </h3>
        </b-row>
        <b-row>
            <b-col>
                <small class="font-weight-bold text-muted"> Category </small>
                <h5>
                    {{ (order.category && order.category.name) || '-' }}
                </h5>
            </b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col>
                <small class="font-weight-bold text-muted"> Created On </small>
                <h5>{{ order.created_at | filterDate }}</h5>
            </b-col>
            <b-col>
                <small class="font-weight-bold text-muted"> Location </small>
                <h5
                    v-html="filterSection(order.delivery_location_section)"
                ></h5>
            </b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col>
                <small class="font-weight-bold text-muted"> Price </small>
                <h5>{{ order.items | filterPrice }}</h5>
            </b-col>
            <b-col>
                <small class="font-weight-bold text-muted">
                    Officer Assigned
                </small>
                <h5>{{ order.driver | filterOfficerName }}</h5>
            </b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col>
                <small class="font-weight-bold text-muted">
                    Reference Number
                </small>
                <h5>{{ order.reference_no }}</h5>
            </b-col>
        </b-row>
    </b-card>
</template>
<style scoped>
h5 {
    font-size: 1em;
}

small {
    font-size: 0.7em;
}
</style>
<script>
export default {
    name: 'Issue',
    props: ['order'],
    filters: {
        filterDate(date) {
            return date.split(' ')[0]
        },
        filterOfficerName(officer) {
            if (!officer) return ''
            return officer.first_name + ' ' + officer.last_name
        },
        filterPrice(items) {
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            })
            const sum = items.reduce((sum, item) => {
                sum +=
                    parseFloat(item.quantity) *
                    parseFloat(item.price) *
                    (1 + parseFloat(item.tax_rate) / 100)
                return sum
            }, 0)
            if (!sum) return '-'

            return formatter.format(sum) /* $2,500.00 */
        },
    },
    methods: {
        filterSection(section) {
            if (!section) return ''
            const { name, location } = section || {}
            const { address1, address2, city } = location || {}
            return `${name}<br/>${address1}<br/>${address2}<br/>${city}`
        },
    },
}
</script>
